// Single source for the Google Maps browser key.
//
// The key is referrer-restricted to hosting.breezelabs.co.uk, so it is safe to
// ship in the bundle but it only works when loaded from that origin.
//
// Both the customer-facing address widget (components/domain/registrationContact.js)
// and the health-check page (pages/gapiAddressCheck.js) import from here, so the
// hourly checker always exercises the same key the customer's browser uses. If
// they were hardcoded separately the check could pass against a stale key while
// the real widget was broken.
export const GOOGLE_MAPS_API_KEY = 'AIzaSyBVSix0J4twHYcrk2htTz97cu4zKwey95w'
